/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_UrgentInputs */

const cs_enum_urgent = /** @type {(inputs: Enum_UrgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urgentní`)
};

const en_enum_urgent = /** @type {(inputs: Enum_UrgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urgent`)
};

/**
* | output |
* | --- |
* | "Urgent" |
*
* @param {Enum_UrgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_urgent = /** @type {((inputs?: Enum_UrgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_UrgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_urgent(inputs)
	return cs_enum_urgent(inputs)
});